import axios from 'axios';
import { getSession } from '../utils/SessionUtils'; // adjust path if needed
import dayjs from 'dayjs';
import { apiCall } from '../utils/ApiUtils';

const BASE_URL = process.env.REACT_APP_UI_BASE_URL;
const companyCode= getSession("COMPANY")


// Save a new grouping (with image upload and section detail images)
export const saveGrouping = async (company = companyCode, grouping, imageFile, sectionDetailImagesFiles) => {
  try {
    const formData = new FormData();
    grouping.companyCode = companyCode;
    grouping.image=undefined
    if(grouping.sectionsDetails){
      grouping.sectionsDetails.forEach(section => {
        section.image = undefined;
        section.companyCode = companyCode; // Ensure companyCode is set correctly
        section.sectionID=grouping.sectionID; // Ensure sectionID is set correctly
      });
    }
    console.log("Saving grouping with data:", sectionDetailImagesFiles);
    // Attach the grouping object as JSON
    formData.append('sections', new Blob([JSON.stringify(grouping)], { type: 'application/json' }));
    // Attach the main image if present
    if (imageFile) {
      formData.append('image', imageFile);
    }
    // Attach section detail images if present (array of files)
    if (Array.isArray(sectionDetailImagesFiles) && sectionDetailImagesFiles.length > 0) {
      sectionDetailImagesFiles.forEach((file, idx) => {
        if (file) {
          formData.append('sectionDetailImages', file);
        }
      });
    }
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/saveGrouping`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Fetch all applicable sections for a company
export const findApplicableSections = async (company = companyCode) => {
  try {
    const response = await apiCall("GET", `${BASE_URL}/${companyCode}/findApplicableSections`);
    return response;
  } catch (error) {
    throw error;
  }
};
// Fetch all categories for a company
export const findAllCategories = async (company = companyCode) => {
  try {
    const response = await apiCall("GET", `${BASE_URL}/${companyCode}/findAllCategories`);
    
    return response;
  } catch (error) {
    throw error;
  }
};

// Fetch all valid banners for a company
export const findAllValidBanners = async (company = companyCode) => {
  try {
    const response = await apiCall("GET", `${BASE_URL}/${companyCode}/findAllValidBanners`);
    
    return response;
  } catch (error) {
    throw error;
  }
};

// Save a new banner config (with image upload)
export const saveBannerConfig = async (company=companyCode, bannerConfig, imageFile) => {
  try {
    const formData = new FormData();
    bannerConfig['companyCode'] = companyCode;
    formData.append('banner', new Blob([JSON.stringify(bannerConfig)], { type: 'application/json' }));
    if (imageFile) {
      formData.append('image', imageFile);
    }
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/saveBannerConfig`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete a banner config by bannerID
export const deleteBannerConfig = async (company = companyCode, bannerID) => {
  try {
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/deleteBannerConfig/${bannerID}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};


// Delete a grouping/section by sectionID
export const deleteSection = async (company = companyCode, sectionID) => {
  console.log("Deleting section with ID:", sectionID);
  try {
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/deleteSections/${sectionID}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//@PostMapping("/{company}/findBannerConfigForFilter")
export const findBannerConfigForFilter = async (company = companyCode, bannerStatus) => {
  console.log("Finding banner config for filter with status:", { bannerStatus });
  try {
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/findBannerConfigForFilter?bannerStatus=${bannerStatus}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//@PostMapping("/{company}/findSectionsForFilter")
export const findSectionsForFilter = async (company = companyCode, sectionStatus) => {
  console.log("Finding sections for filter with status:", { sectionStatus });
  try {
    const response = await apiCall("POST",
      `${BASE_URL}/${companyCode}/findSectionsForFilter?sectionStatus=${sectionStatus}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
